const topics = [
  { name: '#某顶流恋情曝光', heat: '火热', count: '128万讨论', color: 'primary' },
  { name: '#综艺录制现场事故', heat: '火热', count: '96万讨论', color: 'primary' },
  { name: '#品牌代言风云', heat: '热门', count: '73万讨论', color: 'accent' },
  { name: '#网红直播翻车', heat: '热门', count: '68万讨论', color: 'accent' },
  { name: '#年度剧王诞生', heat: '上升', count: '55万讨论', color: 'secondary' },
  { name: '#明星穿搭解析', heat: '上升', count: '42万讨论', color: 'secondary' },
  { name: '#音乐圈新动态', heat: '上升', count: '38万讨论', color: 'secondary' },
  { name: '#吃瓜文化大讨论', heat: '新晋', count: '25万讨论', color: 'secondary' },
  { name: '#下半年前瞻', heat: '新晋', count: '19万讨论', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200/60' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200/60' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200/60' },
};

const heatColorMap: Record<string, string> = {
  '火热': 'bg-primary-500 text-background-50',
  '热门': 'bg-accent-500 text-background-50',
  '上升': 'bg-secondary-500 text-background-50',
  '新晋': 'bg-secondary-300 text-foreground-700',
};

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            话题广场
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic, i) => {
            const c = colorMap[topic.color];
            return (
              <a
                key={i}
                href="#topics"
                className={`flex items-center justify-between p-4 rounded-xl border ${c.border} ${c.bg} bg-opacity-50 hover:bg-opacity-80 transition-all cursor-pointer group`}
              >
                <div className="min-w-0 flex-1">
                  <span className={`block text-sm font-semibold ${c.text} truncate whitespace-nowrap group-hover:text-foreground-950 transition-colors`}>
                    {topic.name}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
                </div>
                <span className={`ml-3 flex-shrink-0 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${heatColorMap[topic.heat] || 'bg-secondary-300 text-foreground-700'}`}>
                  {topic.heat}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}